export const ACCESS_TOKEN_KEY = 'simulador-token-storage';

export const removeToken = async () => {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
};

export const registerToken = async (accessToken: string) => {
  sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
};

export const getAccessToken = async (): Promise<any> => sessionStorage.getItem(ACCESS_TOKEN_KEY);

export const redirectUserToPdP = () =>
  window.location.replace(`${process.env.REACT_APP_PDP_URL}/user/my-simulator`);
  
export const redirectUserToPdPDashboard = () =>
  window.location.replace(`${process.env.REACT_APP_PDP_URL}/user/configuration`);

